import "../../assets/css/RightPanel.css";
import "../../assets/css/AdminTool.css";

import { useState } from "react";
import { Alert, Button, Card, Input, Space, Typography, message } from "antd";

import useAccountDeletionMonitoring from "../../hooks/useAccountDeletionMonitoring";

export default function AccountDeletionAdminActionContainer() {
  const { requestAdminDeleteOtp, confirmAdminDeleteAccount, isLoading } = useAccountDeletionMonitoring();
  const [adminDeleteTargetOsyncId, setAdminDeleteTargetOsyncId] = useState("");
  const [adminDeleteOtp, setAdminDeleteOtp] = useState("");
  const [isAdminDeleteOtpRequested, setIsAdminDeleteOtpRequested] = useState(false);

  const handleRequestAdminDeleteOtp = async () => {
    const targetOsyncId = (adminDeleteTargetOsyncId || "").trim();
    if (!targetOsyncId) {
      message.warning("Enter an osyncId for admin deletion");
      return;
    }
    const payload = await requestAdminDeleteOtp(targetOsyncId);
    if (!payload) {
      return;
    }
    const isValid = payload?.emailResponse?.isValid;
    const responseMessage = payload?.emailResponse?.message || "OTP request failed";
    if (!isValid) {
      message.error(responseMessage);
      return;
    }
    setIsAdminDeleteOtpRequested(true);
    message.success(responseMessage);
  };

  const handleConfirmAdminDelete = async () => {
    const targetOsyncId = (adminDeleteTargetOsyncId || "").trim();
    const otpValue = (adminDeleteOtp || "").trim();
    if (!targetOsyncId) {
      message.warning("Enter an osyncId for admin deletion");
      return;
    }
    if (!otpValue) {
      message.warning("Enter OTP");
      return;
    }
    const response = await confirmAdminDeleteAccount(targetOsyncId, otpValue);
    if (!response?.data) {
      return;
    }
    if (response?.status === 202) {
      message.success(response?.data);
      setAdminDeleteOtp("");
      setIsAdminDeleteOtpRequested(false);
      return;
    }
    message.error(response?.data);
  };

  return (
    <div className="p-4">
      <Typography.Title level={4}>Admin account deletion</Typography.Title>
      <Card title="Admin GDPR deletion" className="mb-4 account-deletion-card">
        <Space direction="vertical" className="w-100">
          <Alert
            type="info"
            showIcon
            message="Request OTP sends the code to every Super Admin on the admin account; any of them can share the OTP with you."
          />
          <Space wrap align="start">
            <Input
              placeholder="Target osyncId"
              value={adminDeleteTargetOsyncId}
              onChange={(e) => setAdminDeleteTargetOsyncId(e.target.value)}
              className="hs-min-w-320-px"
            />
            <Button type="primary" onClick={handleRequestAdminDeleteOtp} loading={isLoading}>
              Request OTP
            </Button>
          </Space>
          <Space wrap align="start">
            <Input
              placeholder="Enter OTP"
              value={adminDeleteOtp}
              onChange={(e) => setAdminDeleteOtp(e.target.value)}
              className="hs-min-w-320-px"
            />
            <Button
              type="primary"
              danger
              onClick={handleConfirmAdminDelete}
              loading={isLoading}
              disabled={!isAdminDeleteOtpRequested}
            >
              Confirm delete
            </Button>
          </Space>
        </Space>
      </Card>
    </div>
  );
}
